import { memo, type CSSProperties } from 'react';
import { cn } from '@/shared/utils/cn';

export interface FileTypeDocumentSilhouetteProps {
  /**
   * `muted`: contorno en tono disabled (zona en reposo o error).
   * `brand`: contorno marca (drag activo sin error), alineado con Figma *File Uploader*.
   */
  variant?: 'muted' | 'brand';
  className?: string;
}

/**
 * Silueta del documento del set Figma `_file types` (mismo vector que `file-type-document-*.svg`),
 * sin badge de extensión — para la zona «Arrastra y suelta» del organismo.
 */
export const FileTypeDocumentSilhouette = memo(function FileTypeDocumentSilhouette({
  variant = 'muted',
  className,
}: FileTypeDocumentSilhouetteProps) {
  return (
    <svg
      role="img"
      aria-hidden
      viewBox="0 0 28 33.3333"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        'ui-pointer-events-none ui-block ui-aspect-[28/33.3333] ui-h-12 ui-w-auto ui-max-w-none ui-shrink-0',
        variant === 'brand' ? 'ui-text-icon-brand' : 'ui-text-disabled',
        className
      )}
      style={
        {
          ['--fill-0']: '#ffffff',
          ['--stroke-0']: 'currentColor',
        } as CSSProperties
      }
    >
      <g id="Vector 19">
        <path
          d="M6 0.666667H14.521C15.8978 0.666667 17.2213 1.19911 18.2145 2.1526L27.3333 10.9067V27.3333C27.3333 30.2789 24.9455 32.6667 22 32.6667H6C3.05448 32.6667 0.666667 30.2789 0.666667 27.3333V6C0.666667 3.05448 3.05448 0.666667 6 0.666667Z"
          fill="var(--fill-0, white)"
        />
        <path
          d="M27.3333 10.9067V27.3333C27.3333 30.2789 24.9455 32.6667 22 32.6667H6C3.05448 32.6667 0.666667 30.2789 0.666667 27.3333V6C0.666667 3.05448 3.05448 0.666667 6 0.666667H14.521C15.8978 0.666667 17.2213 1.19911 18.2145 2.1526L27.3333 10.9067ZM27.3333 10.9067H22C19.0545 10.9067 16.6667 8.51886 16.6667 5.57334V1.30667"
          stroke="var(--stroke-0, #C6C8CC)"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});

FileTypeDocumentSilhouette.displayName = 'FileTypeDocumentSilhouette';
